export default __webpack_public_path__ + "static/media/Pos4.fec74895.svg";